export function toCents(value: number): number {
  return value * 100;
}

export function fromCents(value: number): number {
  return value / 100;
}
